import { render, staticRenderFns } from "./titleStyle.vue?vue&type=template&id=72425165&scoped=true"
import script from "./titleStyle.vue?vue&type=script&lang=js"
export * from "./titleStyle.vue?vue&type=script&lang=js"
import style0 from "./titleStyle.vue?vue&type=style&index=0&id=72425165&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72425165",
  null
  
)

export default component.exports